<template>
    <div class="c-field" :style="rootStyle">
        <label class="c-field__label" :style="labelStyle">
            {{ label }}
            <span v-if="optional" class="c-field__optional" :style="optionalStyle">optional</span>
        </label>
        <slot />
    </div>
</template>

<script>
import { C_INK2, C_MUTED } from './tokens';

export default {
    name: 'CField',
    props: {
        label: { type: String, required: true },
        optional: { type: Boolean, default: false },
    },
    computed: {
        rootStyle() {
            // Defensive: CField is often used inside CSS Grid items where
            // `min-width: auto` (the default) honours intrinsic-min and
            // forces the column wider than its 1fr allocation when the
            // inner input's nowrap content is long. `min-width: 0` lets
            // the grid shrink the cell and the input do its own truncation.
            return { minWidth: 0 };
        },
        labelStyle() {
            return {
                display: 'flex',
                alignItems: 'baseline',
                gap: '8px',
                marginBottom: '6px',
                fontSize: '12px',
                color: C_INK2,
                fontWeight: 600,
            };
        },
        optionalStyle() {
            return { fontSize: '11px', color: C_MUTED, fontWeight: 400 };
        },
    },
};
</script>
